var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinPurple = function SvgLinkedinPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 25.667c6.444 0 11.667-5.224 11.667-11.667S20.444 2.333 14.001 2.333C7.557 2.333 2.334 7.557 2.334 14s5.223 11.667 11.667 11.667zM8.974 9.778a1.506 1.506 0 1 0 0-3.011 1.506 1.506 0 0 0 0 3.011zm-1.506 1.29h3.079v9.465h-3.08V11.07zm11.432.101.032.01a3.07 3.07 0 0 1 2.303 2.967v6.387h-3.078V14.51c-.981-2.38-3.308.86-3.308.86v5.163H11.77V11.07h3.079v1.81c.375-.505 1.513-1.81 3.308-1.81.21 0 .39.023.553.056.042.007.083.014.125.024l.065.02z",
    fill: "#B382BA"
  })));
};
export default SvgLinkedinPurple;